import { Body } from '@spritz-finance/ui'
import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { Spinner } from './Spinner/Spinner'

const Container = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
`

const TextContainer = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
`

const ContentContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column-reverse;
`

const PageLoading: React.FC<{ style?: CSSProperties; label?: string }> = ({ style, label }) => {
    return (
        <Container style={style}>
            <ContentContainer>
                <Spinner />
                {label && (
                    <TextContainer>
                        <Body.Med size={20}>{label}</Body.Med>
                    </TextContainer>
                )}
            </ContentContainer>
        </Container>
    )
}

export { PageLoading }
